import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAtomValue } from "jotai";

import PaymentStatusTemplate, {
  PaymentStatusType,
} from "../../../components/Payments/PaymentStatusTemplate/PaymentStatusTemplate";
import EventDispatcher from "../../../utils/event-dispatcher";
import {
  EventTypes,
  MOBILE_APP_TO_WEB_APP_ROUTE_MAP,
  ROUTES,
} from "../../../utils/constants";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../../utils/renderHeaders";
import CheckmarkCircleIconWithBorder from "../../../components/icons/CheckmarkCircleIconWithBorder";
import useAnalytics from "../../../hooks/useAnalytics";
import {
  paymentStatusAtom,
  PaymentStatuses,
  topupInfoAtom,
} from "../../../jotai/atoms/topup";
import useEffectAfterMount from "../../../hooks/useEffectAfterMount";

const REDIRECT_ROUTE = ROUTES.WALLET.TOPUP_SUCCESSFUL_FIRST;

function PaymentSuccessfulMobile() {
  const { t } = useTranslation("wallet");
  const { sendCompleteTopupEvent, sendSuccessfulTopupEvent } = useAnalytics();
  const topupInfo = useAtomValue(topupInfoAtom);
  const paymentStatus = useAtomValue(paymentStatusAtom);

  useEffect(() => {
    EventDispatcher.dispatch(EventTypes.PAYMENTS.SUCCESSFUL, {
      message: t("your_payment_has_been_confirmed"),
    });
    window.location.href = MOBILE_APP_TO_WEB_APP_ROUTE_MAP[REDIRECT_ROUTE];
  }, [t]);

  useEffectAfterMount(() => {
    if (topupInfo?.provider && paymentStatus) {
      const {
        provider,
        amount,
        price,
        isFirstTime,
        bonusHpr,
        gem,
        topUpUniqueId,
      } = topupInfo;
      sendCompleteTopupEvent({
        hpr_amount: amount,
        bonus_hpr_amount: bonusHpr ?? 0,
        gem_amount: gem ?? 0,
        fiat_amount: price ?? 0,
        first_time_top_up: isFirstTime,
        transaction_status: paymentStatus,
        payment_option: provider.toLowerCase(),
        topUpUniqueId,
      });
      sendSuccessfulTopupEvent({
        hpr_amount: amount,
        bonus_hpr_amount: bonusHpr ?? 0,
        gem_amount: gem ?? 0,
        fiat_amount: price ?? 0,
        first_time_top_up: isFirstTime,
        transaction_status: PaymentStatuses.SUCCESSFUL,
        payment_option: provider.toLowerCase(),
        topUpUniqueId,
      });
    }
  }, [
    topupInfo,
    paymentStatus,
    sendCompleteTopupEvent,
    sendSuccessfulTopupEvent,
  ]);

  return (
    <>
      {renderHeaders({
        title: t("metadata:payment_successful_hyper_by_metaverse_magna"),
        description: "",
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:payment_successful_hyper_by_metaverse_magna"),
        ),
      })}

      <PaymentStatusTemplate
        type={PaymentStatusType.DONE}
        title={t("payment_confirmed")}
        message={t("your_payment_has_been_confirmed")}
        eventType={EventTypes.PAYMENTS.SUCCESSFUL}
        navigateUrl={REDIRECT_ROUTE}
        icon={<CheckmarkCircleIconWithBorder />}
      />
    </>
  );
}

export default PaymentSuccessfulMobile;
